
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
  components: { VueSlickCarousel },
  data() {
    return {
      items: [],
      options: [
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "image",
          label: "Slika",
          type: "image",
          size: "400x400",
        },
      ],
      settings: {
        infinite: false,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1.4,
            },
          },

          {
            breakpoint: 550,
            settings: {
              slidesToShow: 2.1,
            },
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2.4,
            },
          },
        ],
      },
    };
  },
  mounted() {
    if (
      this.$refs.awards &&
      this.$refs.awards.items &&
      this.$refs.awards.items.length
    ) {
      this.items = this.$refs.awards.items;
    }
  },
};
